// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"405":"79f6cb21","639":"79f6cb21","920":"79f6cb21","967":"79f6cb21"}[chunkId] + ".chunk.css";
};